module.exports = __webpack_public_path__ + "static/net600-67105c527890724f73202bfde526484e.svg";